const deleteUserAvatar = async (_, args, context) => {
  const {
    userId
  } = args;
  const url = `${context.url.stargateRoot}/users/${userId}/manage/avatar`;
  return context.fetch(url, {
    method: 'DELETE'
  }).then(() => true);
};
export default deleteUserAvatar;